module.exports = __webpack_public_path__ + "static/media/IMG_0040.1dabccab.JPG";